import { useState } from "react";
import "./AddProduct.css";
import "../screens/Reports.css"; /* for perm-grid and toggle-switch styles */
import { useNavigate } from "react-router-dom";
import dataService from "../services/dataService";

function AddUser() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    username: "",
    employeeId: "",
    password: "",
    confirmPassword: "",
    role: "Staff",
    department: "",
    location: "Advertising Point Office",
    reportsTo: "",
    status: "Active",
    sendWelcomeEmail: false,
    requirePasswordChange: false
  });

  const [permissions, setPermissions] = useState({
    general: { viewDashboard: false },
    crm: { viewCustomers: false, editCustomers: false, deleteCustomers: false },
    vendor: { viewVendor: false, editVendor: false },
    product: { viewProduct: false, editProduct: false },
    purchase: { viewPurchase: false, createPurchaseOrder: false },
    sales: { viewSalesOrder: false, createSalesOrder: false },
    invoice: { viewInvoice: false, createInvoice: false },
    payments: { viewPayments: false, recordPayments: false },
    expenses: { viewExpenses: false, createExpenses: false },
    reports: { viewReports: false },
    administration: { manageUser: false }
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePermissionChange = (section, field) => {
    setPermissions(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: !prev[section][field]
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    const payload = {
      ...formData,
      name: `${formData.firstName} ${formData.lastName}`,
      permissions
    };

    try {
      await dataService.addUser(payload);
      navigate("/users");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-vendor-page">
      <div className="page-header">
        <h1>Add New User</h1>
        <p>Create a new user account with role and permission</p>
      </div>

      {error && <div className="error-message" style={{ color: 'red', marginBottom: '20px', padding: '10px', background: '#fee2e2', borderRadius: '4px' }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="vendor-grid">
          {/* LEFT SIDE (80%) */}
          <div className="vendor-left">
            <div className="vendor-card">
              <h2>User Information</h2>
              <div className="v-name">
                <div>
                  <p>First Name</p>
                  <input name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="Enter first name" />
                </div>
                <div>
                  <p>Last Name</p>
                  <input name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Enter Last name" />
                </div>
              </div>

              <div className="v-name">
                <div>
                  <p>Email Address</p>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="user@example.com" />
                </div>
                <div>
                  <p>Phone Number</p>
                  <input name="phone" value={formData.phone} onChange={handleChange} placeholder="+1 234 567 8900" />
                </div>
              </div>

              <div className="v-name">
                <div>
                  <p>User Name</p>
                  <input name="username" value={formData.username} onChange={handleChange} required placeholder="Enter user name" />
                </div>
                <div>
                  <p>Employee Id</p>
                  <input name="employeeId" value={formData.employeeId} onChange={handleChange} placeholder="EMP-XXXX" />
                </div>
              </div>

              <div className="v-name">
                <div>
                  <p>Password</p>
                  <input type="password" name="password" value={formData.password} onChange={handleChange} required placeholder="Enter password" />
                </div>
                <div>
                  <p>Confirm Password</p>
                  <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required placeholder="Confirm password" />
                </div>
              </div>
            </div>

            <div className="vendor-card">
              <h2>Permissions</h2>

              <div className="perm-grid">
                {/* General */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">🏠</span><h4>General</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Dashboard</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.general.viewDashboard} onChange={() => handlePermissionChange('general', 'viewDashboard')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* CRM */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">👥</span><h4>CRM</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Customers</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.crm.viewCustomers} onChange={() => handlePermissionChange('crm', 'viewCustomers')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Edit Customers</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.crm.editCustomers} onChange={() => handlePermissionChange('crm', 'editCustomers')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Delete Customers</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.crm.deleteCustomers} onChange={() => handlePermissionChange('crm', 'deleteCustomers')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Vendor */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">🏭</span><h4>Vendor</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Vendor</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.vendor.viewVendor} onChange={() => handlePermissionChange('vendor', 'viewVendor')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Edit Vendor</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.vendor.editVendor} onChange={() => handlePermissionChange('vendor', 'editVendor')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Product */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">📦</span><h4>Product</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Product</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.product.viewProduct} onChange={() => handlePermissionChange('product', 'viewProduct')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Edit Product</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.product.editProduct} onChange={() => handlePermissionChange('product', 'editProduct')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Purchase */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">🛒</span><h4>Purchase</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Purchase</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.purchase.viewPurchase} onChange={() => handlePermissionChange('purchase', 'viewPurchase')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Create Purchase Order</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.purchase.createPurchaseOrder} onChange={() => handlePermissionChange('purchase', 'createPurchaseOrder')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Sales */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">📈</span><h4>Sales</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Sales Order</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.sales.viewSalesOrder} onChange={() => handlePermissionChange('sales', 'viewSalesOrder')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Create Sales Order</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.sales.createSalesOrder} onChange={() => handlePermissionChange('sales', 'createSalesOrder')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Invoice */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">🧾</span><h4>Invoice</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Invoice</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.invoice.viewInvoice} onChange={() => handlePermissionChange('invoice', 'viewInvoice')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Create Invoice</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.invoice.createInvoice} onChange={() => handlePermissionChange('invoice', 'createInvoice')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Payments */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">💳</span><h4>Payments</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Payments</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.payments.viewPayments} onChange={() => handlePermissionChange('payments', 'viewPayments')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Record Payments</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.payments.recordPayments} onChange={() => handlePermissionChange('payments', 'recordPayments')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Expenses */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">💸</span><h4>Expenses</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Expenses</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.expenses.viewExpenses} onChange={() => handlePermissionChange('expenses', 'viewExpenses')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Create Expenses</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.expenses.createExpenses} onChange={() => handlePermissionChange('expenses', 'createExpenses')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Reports */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">📊</span><h4>Reports</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">View Reports</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.reports.viewReports} onChange={() => handlePermissionChange('reports', 'viewReports')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>

                {/* Administration */}
                <div className="perm-card">
                  <div className="perm-card-header">
                    <span className="perm-icon">🔐</span><h4>Administration</h4>
                  </div>
                  <div className="perm-toggle-row">
                    <span className="perm-label">Manage Users</span>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={permissions.administration.manageUser} onChange={() => handlePermissionChange('administration', 'manageUser')} />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="vendor-right">
            <div className="vendor-card">
              <h2>Role Assignment</h2>
              <div className="v-namer">
                <p>User Role</p>
                <select name="role" value={formData.role} onChange={handleChange} required>
                  <option value="Admin">Admin</option>
                  <option value="Manager">Manager</option>
                  <option value="Staff">Staff</option>
                </select>
                <p style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                  <strong>Admin:</strong> Full system access with all permissions<br />
                  <strong>Manager:</strong> Can view and edit most resources<br />
                  <strong>Staff:</strong> Limited to viewing and basic operations
                </p>
              </div>
            </div>

            <div className="vendor-card">
              <h2>Department and Location</h2>
              <div className="v-namer">
                <p>Department</p>
                <select name="department" value={formData.department} onChange={handleChange}>
                  <option value="">Select Department</option>
                  <option value="Sales">Sales</option>
                  <option value="Operations">Operations</option>
                  <option value="Finance">Finance</option>
                  <option value="IT">IT</option>
                  <option value="Human Resource">Human Resource</option>
                  <option value="Administration">Administration</option>
                </select>
                <p>Office Location</p>
                <select name="location" value={formData.location} onChange={handleChange}>
                  <option value="Advertising Point Office">Advertising Point Office</option>
                </select>
                <p>Reports To</p>
                <select name="reportsTo" value={formData.reportsTo} onChange={handleChange}>
                  <option value="">Select Manager</option>
                  <option value="John Doe">John Doe</option>
                  <option value="Jane Smith">Jane Smith</option>
                  <option value="Mike Johnson">Mike Johnson</option>
                </select>
              </div>
            </div>

            <div className="vendor-card">
              <h2>Account Settings</h2>
              <div className="v-namer">
                <p>Account Status</p>
                <select name="status" value={formData.status} onChange={handleChange}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Pending Activation">Pending Activation</option>
                </select>
                <label className="permission-item" style={{ marginTop: '10px' }}>
                  <input type="checkbox" name="sendWelcomeEmail" checked={formData.sendWelcomeEmail} onChange={handleChange} />
                  <span>send welcome email with login details</span>
                </label>
                <label className="permission-item">
                  <input type="checkbox" name="requirePasswordChange" checked={formData.requirePasswordChange} onChange={handleChange} />
                  <span>Require password change on first login</span>
                </label>
              </div>
            </div>

            <div className="vendor-actions">
              <button type="button" className="secondary-btn" onClick={() => navigate("/users")}>Cancel</button>
              <button type="submit" className="primary-btn" disabled={loading}>
                {loading ? "Creating..." : "Create User"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddUser;
